import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from '@totalsoft/rocket-ui';
import SyncIcon from '@mui/icons-material/Sync';
import { useTranslation } from 'react-i18next';
import { CardActionsContainer } from 'components/common/CardStyles';

const InvalidateCacheComponent = ({
  onInvalidateCredentials,
  onInvalidateConfigurations,
  invalidateCredentialsDisabled,
  invalidateConfigurationsDisabled
}) => {
  const { t } = useTranslation();

  return (
    <Card title={t('Settings.InvalidateCache.Title')} icon={SyncIcon}>
      <CardActionsContainer>
        <Button id='invalidateCache_invalidateCredentialsButton' onClick={onInvalidateCredentials} disabled={invalidateCredentialsDisabled}>
          {invalidateCredentialsDisabled
            ? t('Settings.InvalidateCache.InvalidatingCredentials')
            : t('Settings.InvalidateCache.InvalidateCredentials')}
        </Button>
        <Button
          id='invalidateCache_invalidateConfigurationsButton'
          onClick={onInvalidateConfigurations}
          disabled={invalidateConfigurationsDisabled}
        >
          {invalidateConfigurationsDisabled
            ? t('Settings.InvalidateCache.InvalidatingConfigurations')
            : t('Settings.InvalidateCache.InvalidateConfigurations')}
        </Button>
      </CardActionsContainer>
    </Card>
  );
};

InvalidateCacheComponent.propTypes = {
  onInvalidateCredentials: PropTypes.func.isRequired,
  onInvalidateConfigurations: PropTypes.func.isRequired,
  invalidateCredentialsDisabled: PropTypes.bool.isRequired,
  invalidateConfigurationsDisabled: PropTypes.bool.isRequired
};

export default InvalidateCacheComponent;
